module.exports = __webpack_public_path__ + "static/media/marron.124fb50d.png";